<template>
  <v-menu
    v-model="opened"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <a class="decoration-link caption ml-1" v-on="{ ...onTooltip, ...on }">
            alterar
          </a>
        </template>
        <span>
          Alterar quantidade
        </span>
      </v-tooltip>
    </template>
    <v-card class="mx-auto"
            min-width="300"
            max-width="400">
      <v-card-text>
        <v-row dense no-gutters class="mt-4">
          <v-col cols="12">
            <px-input-number label="Quantidade"
                             required
                             hide-details
                             autofocus
                             class="required"
                             :error="$v.quantidade.$error"
                             @blur="$v.quantidade.$touch()"
                             @keyup.enter="save"
                             v-model="quantidade"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary"
               class="rounded-tag-small ml-3 mb-3"
               :disabled="$v.$invalid"
               :loading="loading"
               @click="save">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import CarrinhoService from '../carrinhos-marketplace-service';

export default {
  props: {
    icon: {
      type: String,
      default: 'mdi-pencil',
    },
    oferta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      opened: false,
      loading: false,
      quantidade: null,
    };
  },
  methods: {
    close() {
      this.opened = false;
    },
    buildInitialState() {
      this.quantidade = this.oferta.quantidade;
    },
    buildPayload() {
      return {
        quantidade: this.quantidade,
      };
    },
    save() {
      this.loading = true;
      CarrinhoService.update(this.oferta.id, this.buildPayload())
        .then(() => {
          this.$toast('Oferta atualizada', { color: 'success' });
          this.$emit('change');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    opened(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.buildInitialState();
    },
  },
  validations: {
    quantidade: {
      required,
    },
  },
};
</script>
